import { Switch } from '@mantine/core';
import { useAtom } from 'jotai';
import { debugModeAtom } from '~/atoms/no-code-atoms';

export function DebugModeToggle() {
  const [debugMode, setDebugMode] = useAtom(debugModeAtom);

  return (
    <Switch
      checked={debugMode}
      onChange={() => setDebugMode((prev) => !prev)}
      color="orange"
      label="Operation Debug Info"
    />
  );
}
